/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  AppDetailsPageEvent,
  useAppDetailsPageDataSelector,
} from "../AppDetailsPage";
import { useMainPageDataSelector, MainPageEvent } from "../../MainUi";
import HmsInput from "../../Common/element/HmsInput";
import HmsDropdown from "../../Common/element/HmsDropdown";
import Modal from "react-bootstrap/Modal";

interface ModalProps {
  appId: string;
}

function AppReviewModal({ appId }: ModalProps) {
  const [review, setReview] = useState<string>("");
  const [commentType, setCommentType] = useState<string>("");

  const mainPageData = useMainPageDataSelector();
  const pageData = useAppDetailsPageDataSelector();

  useEffect(() => {}, []);

  const dispatch = useDispatch();

  const validationProps = {
    minLength: 1,
    maxLength: 256,
    lengthErrorMsg: "Review must be within 1 and 256 characters",
  };

  const commentTypes = [
    {
      label: "User Comment",
      value: "USER_COMMENT",
    },
    {
      label: "Report Abused",
      value: "REPORT_ABUSED",
    },
  ];

  const validateComment = () => {
    return (
      review.length > validationProps.minLength &&
      review.length <= validationProps.maxLength
    );
  };

  const submitReview = () => {
    if (validateComment()) {
      dispatch({
        type: AppDetailsPageEvent.SUBMIT_REVIEW,
        payload: {
          appId,
          comment: review,
          name: `${mainPageData?.appUser?.firstName} ${mainPageData?.appUser?.lastName}`,
          msisdn: mainPageData?.appUser?.msisdn,
        },
        token: mainPageData.authToken ? mainPageData.authToken : null,
      });
    }
    if (review.length === 0) {
      dispatch({
        type: MainPageEvent.SHOW_NOTIFICATION,
        payload: "Cannot add empty review",
      });
    }
  };

  return (
    <Modal
      show={pageData.showAddReviewModal}
      onHide={() => {
        dispatch({
          type: AppDetailsPageEvent.HIDE_ADD_REVIEW_MODAL,
        });
      }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Write a Review</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <HmsDropdown
          className="form-control bg-back border-0"
          title="Comment Type"
          value={commentType}
          options={commentTypes}
          handleChange={setCommentType}
        />
        <HmsInput
          inputType="textarea"
          className="form-control bg-back border-0 mt-4"
          placeHolder="Review"
          value={review}
          validProps={validationProps}
          handleChange={setReview}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-light"
          data-dismiss="modal"
          onClick={() => {
            dispatch({
              type: AppDetailsPageEvent.HIDE_ADD_REVIEW_MODAL,
            });
          }}
        >
          Close
        </button>
        <button
          disabled={pageData.addingReview}
          className="btn btn-primary"
          onClick={() => submitReview()}
        >
          <i
            className={
              pageData.addingReview ? "fas fa-spin fa-circle-notch" : ""
            }
          ></i>
          {pageData.addingReview ? "Adding..." : "Add"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default AppReviewModal;
